/* ============================================================
   MAISON CANDELIA — conversion.js
   Phase 2 : mini-cart drawer + sticky add-to-cart + quick add
   ============================================================ */
(function () {
  'use strict';

  var FREE_SHIPPING_CENTS = window.FREE_SHIPPING_CENTS || 3000; /* défini dans theme.liquid via settings */

  /* ---------- Helpers ---------- */
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function thumb(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var drawer   = document.getElementById('mini-cart');
  var overlay  = document.getElementById('mini-cart-overlay');
  var itemsEl  = document.getElementById('mini-cart-items');
  var shipText = document.getElementById('mini-cart-shipping-text');
  var shipFill = document.getElementById('mini-cart-progress-fill');
  var subEl    = document.getElementById('mini-cart-subtotal');
  var closeBtn = document.getElementById('mini-cart-close');
  var isCartPage = document.body.classList.contains('template-cart');

  /* ---------- Compteur header ---------- */
  function updateHeaderCount(count) {
    document.querySelectorAll('.header-icon[href="/cart"]').forEach(function (link) {
      var badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  /* ---------- Drawer ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('visible');
    document.body.classList.add('mini-cart-open');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('visible');
    document.body.classList.remove('mini-cart-open');
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Barre livraison offerte ---------- */
  function renderShipping(totalCents) {
    if (!shipText || !shipFill) return;
    var pct = Math.min(100, Math.round(totalCents / FREE_SHIPPING_CENTS * 100));
    shipFill.style.width = pct + '%';
    if (totalCents >= FREE_SHIPPING_CENTS) {
      shipFill.classList.add('complete');
      shipText.innerHTML = '\uD83C\uDF89 <strong>Livraison offerte</strong> sur ta commande !';
    } else {
      shipFill.classList.remove('complete');
      var remaining = FREE_SHIPPING_CENTS - totalCents;
      shipText.innerHTML = 'Plus que <strong>' + money(remaining) + '</strong> pour la livraison offerte \uD83D\uDE9A';
    }
  }

  /* ---------- Rendu du panier ---------- */
  function renderCart(cart) {
    updateHeaderCount(cart.item_count);
    renderShipping(cart.items_subtotal_price);
    if (subEl) subEl.textContent = money(cart.items_subtotal_price);
    var mcLoyalty = document.getElementById('mini-cart-loyalty');
    var mcPoints  = document.getElementById('mc-points');
    if (mcPoints) {
      var pts = Math.floor(cart.items_subtotal_price / 100) * 5;
      mcPoints.textContent = pts;
    }
    if (mcLoyalty) mcLoyalty.style.display = cart.item_count === 0 ? 'none' : '';

    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="mini-cart__empty">' +
        'Ton panier attend son premier voyage\u2026' +
        '<a href="/collections/voyage" class="btn btn--primary" style="display:inline-block;">D\u00e9couvrir les bougies</a>' +
        '<a href="/pages/quiz" class="mini-cart__empty-quiz">Laisse-toi guider : fais le quiz olfactif \u2192</a>' +
        '</div>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      html +=
        '<div class="mini-cart-item" data-key="' + esc(item.key) + '">' +
          (item.image
            ? '<img class="mini-cart-item__img" src="' + esc(thumb(item.image, 128)) + '" alt="" width="64" height="64" loading="lazy">'
            : '<div class="mini-cart-item__img"></div>') +
          '<div class="mini-cart-item__body">' +
            '<a class="mini-cart-item__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            (variant ? '<div class="mini-cart-item__variant">' + esc(variant) + '</div>' : '') +
            '<div class="mini-cart-item__row">' +
              '<span class="mini-cart-item__qty">' +
                '<button type="button" data-qty-change="-1" aria-label="R\u00e9duire la quantit\u00e9">\u2212</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-change="1" aria-label="Augmenter la quantit\u00e9">+</button>' +
              '</span>' +
              '<span class="mini-cart-item__price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="mini-cart-item__remove" data-remove>Retirer</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function openDrawerAndRefresh() {
    if (!drawer) return;
    if (itemsEl && itemsEl.innerHTML.trim() === '') {
      itemsEl.innerHTML = '<div class="mini-cart__empty">Chargement\u2026</div>';
    }
    openDrawer();
    refreshCart();
  }

  /* ---------- Quantités / suppression ---------- */
  var qtyBusy = false;
  function changeQty(key, quantity) {
    if (qtyBusy) return;
    qtyBusy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {})
      .finally(function () { qtyBusy = false; });
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.mini-cart-item');
      if (!row) return;
      var key = row.dataset.key;
      var qtyEl = row.querySelector('.mini-cart-item__qty span');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var change = e.target.closest('[data-qty-change]');
      if (change) {
        var next = current + parseInt(change.dataset.qtyChange, 10);
        changeQty(key, Math.max(0, next));
      } else if (e.target.closest('[data-remove]')) {
        changeQty(key, 0);
      }
    });
  }

  /* ---------- Interception des formulaires add-to-cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    addFromForm(form);
  }, true);

  function addFromForm(form) {
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? (btn.querySelector('span') || btn) : null;
    var original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Ajout en cours\u2026';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = '\u2713 Ajout\u00e9';
        openDrawerAndRefresh();
        setTimeout(function () {
          if (label) label.textContent = original;
          if (btn) btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        if (label) label.textContent = 'Oups \u2014 r\u00e9essaie';
        if (btn) btn.disabled = false;
        setTimeout(function () { if (label) label.textContent = original; }, 2500);
      });
  }

  /* ---------- Quick add (cartes produit) + icône panier header ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var id = qa.getAttribute('data-quick-add');
      var original = qa.textContent;
      qa.textContent = 'Ajout\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          qa.textContent = '\u2713 Ajout\u00e9';
          openDrawerAndRefresh();
          setTimeout(function () { qa.textContent = original; }, 1600);
        })
        .catch(function () {
          qa.textContent = original;
        });
      return;
    }
    var cartLink = e.target.closest('.header-icon[href="/cart"]');
    if (cartLink && drawer && !isCartPage) {
      e.preventDefault();
      openDrawerAndRefresh();
    }
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var sticky = document.getElementById('sticky-atc');
  if (sticky) {
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    var mainBtn = document.getElementById('add-to-cart-btn') ||
      (mainForm ? mainForm.querySelector('[type="submit"]') : null);
    var stickyBtn = document.getElementById('sticky-atc-btn');

    if (mainForm && mainBtn && stickyBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(mainBtn);

      stickyBtn.addEventListener('click', function () {
        if (typeof mainForm.requestSubmit === 'function') {
          mainForm.requestSubmit();
        } else {
          mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });

      /* Synchronisation prix + disponibilité avec la fiche */
      if ('MutationObserver' in window) {
        var priceSrc = document.getElementById('price-display');
        var priceDst = document.getElementById('sticky-atc-price');
        if (priceSrc && priceDst) {
          new MutationObserver(function () {
            priceDst.textContent = priceSrc.textContent.trim();
          }).observe(priceSrc, { childList: true, characterData: true, subtree: true });
        }
        new MutationObserver(function () {
          stickyBtn.disabled = mainBtn.disabled;
        }).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      }
    }
  }

})();
